import { URL_PRODUCTS_AD_BUDGETS } from '@seek/adv-constants';
import { useTranslations } from '@vocab/react';
import {
  Actions,
  Box,
  Button,
  Column,
  Columns,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';

import { BUY_AN_ADPACK_PRESSED } from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';
import { useLocalisedRoutes } from 'src/app/v1/views/hooks/useLocalisedRoutes';
import type { TrackingEvent } from 'src/types/trackingData';

import translations from './.vocab';
import UpsellIcon from './UpsellIcon';

export const UpsellPanel = () => {
  const { t } = useTranslations(translations);
  const { goToExternalRoute } = useLocalisedRoutes();

  const handleOnClick = () => {
    const eventData: TrackingEvent = {
      objectInteraction: 'buy-an-ad-pack',
      eventName: BUY_AN_ADPACK_PRESSED,
    };
    getTrackingAdapter.sendLinkEvent(eventData);

    goToExternalRoute(URL_PRODUCTS_AD_BUDGETS);
  };

  return (
    <Box background="neutralLight" padding="gutter" borderRadius="large">
      <Columns reverse space="gutter" collapseBelow="tablet">
        <Column width="content">
          <Columns space="xsmall">
            <Column>
              <Box
                background="surface"
                borderRadius="full"
                padding={{ mobile: 'small', tablet: 'medium' }}
                display="inlineBlock"
              >
                <UpsellIcon />
              </Box>
            </Column>
          </Columns>
        </Column>
        <Column>
          <Stack space="large">
            <Heading level="4">{t('upsell-panel-subheading')}</Heading>
            <Text tone="secondary">{t('upsell-panel-text')}</Text>
            <Actions>
              <Button onClick={handleOnClick} variant="ghost">
                {t('upsell-panel-button-text')}
              </Button>
            </Actions>
          </Stack>
        </Column>
      </Columns>
    </Box>
  );
};
